import { Spacer } from "@nextui-org/react";
import { useEffect } from "react";

import { Text } from "@/components/customComponents";
import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import Trans from "@/components/Trans/Trans";
import { TEN_SECONDS } from "@/constants";
import { useLocalizedPathname } from "@/hooks/useLocalizedPathname";

const Welcome = () => {
  const localizePath = useLocalizedPathname();
  useEffect(() => {
    const timeout = setTimeout(() => {
      window.location.href = localizePath("/");
    }, TEN_SECONDS);
    return () => {
      clearTimeout(timeout);
    };
  }, [localizePath]);
  return (
    <div>
      <Text h1>
        <Trans i18nKey="subscription:welcomePage.title" />
      </Text>
      <Spacer y={5} />
      <Text>
        <Trans i18nKey="subscription:welcomePage.setupMessage" />
      </Text>
      <Spacer y={6} />
      <Text>
        <Trans
          i18nKey="subscription:welcomePage.redirectMessage"
          components={{
            1: <LocalizedLink className="text-link" to="/" aria-label="redirect" />,
          }}
        />
      </Text>
    </div>
  );
};
export default Welcome;
